<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
    <circle cx="40" cy="40" r="33.3333" fill="#F2BA00" stroke="#FA7E25" stroke-width="3.33333" />
    <path
      d="M32.5 53.5396C37.4462 56.8826 43.3333 56.8826 47.5 53.5396"
      stroke="#813612"
      stroke-width="5"
      stroke-linecap="round"
    />
    <rect x="23.3359" y="26.668" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="25" y="28.332" width="5" height="5" rx="2.5" fill="white" />
    <rect x="46.6641" y="26.668" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="48.3359" y="28.332" width="5" height="5" rx="2.5" fill="white" />
  </svg>
</template>
